import React, { useCallback, useMemo } from 'react';
import { Button, Tooltip, message, Popconfirm } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import AccountService from '../../../Services/AccountsService';

const XBOX_BLOCKED = 'XBoxBlocked';

const XBoxBlockedButton = ({ record, afterUpdate }) => {
  const isBlocked = useMemo(
    () => Array.isArray(record?.condition) && record.condition.includes(XBOX_BLOCKED),
    [record]
  );

  const handleConfirm = useCallback(() => {
    AccountService.setAccountCondition(record.id, XBOX_BLOCKED, !isBlocked)
      .then(() => {
        message.success(isBlocked ? 'Xbox Blocked condition removed' : 'Account marked as Xbox Blocked');
        afterUpdate && afterUpdate();
      })
      .catch((err) => {
        message.error(`Failed to update condition: ${err}`);
      });
  }, [record, isBlocked, afterUpdate]);

  const title = isBlocked ? 'Remove Xbox Blocked' : 'Mark as Xbox Blocked';
  const confirmText = isBlocked
    ? 'Remove Xbox Blocked condition from this account?'
    : 'Mark this account as Xbox Blocked? It will stop taking redeem/purchase jobs.';

  return (
    <Tooltip placement="topLeft" title={title}>
      <Popconfirm title={confirmText} onConfirm={handleConfirm} okText="Yes" cancelText="No">
        <Button
          type={isBlocked ? 'default' : 'primary'}
          danger={isBlocked}
          icon={<StopOutlined />}
        />
      </Popconfirm>
    </Tooltip>
  );
};

export default React.memo(XBoxBlockedButton);
